import { Modal } from "./Modal";
import { Button } from "./Button";
import { AlertTriangle, Info, AlertCircle } from "lucide-react";

interface AlertModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  variant?: "warning" | "info" | "error";
  confirmLabel?: string;
}

const iconStyles = {
  warning: "bg-amber-100 text-amber-600",
  info: "bg-blue-100 text-blue-600",
  error: "bg-red-100 text-red-600",
};

/** In-app pop-up (i.p.v. de browser-alert) voor waarschuwingen/informatieve
 *  meldingen. Sluit alleen met de bevestigingsknop of Escape. */
export function AlertModal({
  isOpen,
  onClose,
  title = "Let op",
  message,
  variant = "warning",
  confirmLabel = "Begrepen",
}: AlertModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="flex items-start gap-4">
        <div
          className={`flex-shrink-0 w-11 h-11 rounded-full flex items-center justify-center ${iconStyles[variant]}`}
        >
          {variant === "warning" && <AlertTriangle size={22} />}
          {variant === "info" && <Info size={22} />}
          {variant === "error" && <AlertCircle size={22} />}
        </div>
        <p className="text-sm text-slate-600 leading-relaxed pt-2">{message}</p>
      </div>
      <div className="mt-6 flex justify-end">
        <Button onClick={onClose}>{confirmLabel}</Button>
      </div>
    </Modal>
  );
}